module.exports = __webpack_public_path__ + "static/img/info_box.3e064eb2.png";